<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Cerrar Caja Registradora"
  [style]="{ width: '400px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12">
            <p-message
              severity="info"
              text="Asegurese de ingresar los datos correctamente, no se puede modificar el registro después de cerrar la caja."
              styleClass="p-mr-2"
            ></p-message>
          </div>
          <div class="field col-12 md:col-12">
            <label>Saldo Final</label>
            <input
              pInputText
              formControlName="endingBalance"
              type="number"
              min="0"
              step="10"
              pattern="^\d*(\.\d{0,2})?$"
            />
          </div>
          <div class="field col-12 md:col-6"></div>
          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar"
            ></button>
          </div>
          <div class="field col-12 md:col-3">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="!checkReadyToOpen()"
              label="Si"
              pTooltip="Cerrar Caja"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
